import { INewsDetailReponse } from "../../../model/base/response/news-detail-response";

export interface NewsDetailState {
    detail: INewsDetailReponse | null;
    loading: boolean;
    error: string | null;
}

export const ACTION_TYPES = {
    setDetail: 'SET_DETAIL' as const,
    setLoading: 'SET_LOADING' as const,
    setError: 'SET_ERROR' as const,
};

type Action =
    | { type: 'SET_DETAIL'; payload: INewsDetailReponse }
    | { type: 'SET_LOADING'; payload: boolean }
    | { type: 'SET_ERROR'; payload: string };

export const NewsDetailReducer = (state: NewsDetailState, action: Action): NewsDetailState => {
    switch (action.type) {
        case ACTION_TYPES.setDetail:
            return {
                ...state,
                detail: action.payload,
                loading: false,
                error: null,
            };
        case ACTION_TYPES.setLoading:
            return {
                ...state,
                loading: action.payload,
            };
        case ACTION_TYPES.setError:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        default:
            return state;
    }
};
